import React from 'react';

const Header = React.memo(() => (
  <header className="bg-white shadow">
    <div className="max-w-auto mx-auto px-4 sm:px-6 lg:px-48 py-6">
      <p className="mt-2 text-sm text-gray-600">
        파판14 구역별 보상과 비공정 드랍테이블을 확인하세요.
      </p>
      <a className="text-theme-headerrow" href='https://submarine.girin.dev/' target='_blank' rel="noreferrer">
        잠수함사이트로 가려면 클릭
      </a>
    </div>
  </header>
));

export default Header;